import { forwardRef, type LabelHTMLAttributes, type ReactNode } from "react";
import { cn } from "@/components/ui/cn";

type VLabelProps = LabelHTMLAttributes<HTMLLabelElement> & {
  required?: boolean;
  optional?: boolean;
  children: ReactNode;
};

export const VLabel = forwardRef<HTMLLabelElement, VLabelProps>(
  ({ className, required, optional, children, ...props }, ref) => (
    <label
      ref={ref}
      className={cn("text-sm font-medium text-foreground", className)}
      {...props}
    >
      {children}
      {required ? <span className="ml-0.5 text-error-600">*</span> : null}
      {optional ? (
        <span className="ml-1 font-normal text-muted-foreground">(optioneel)</span>
      ) : null}
    </label>
  ),
);
VLabel.displayName = "VLabel";

export type { VLabelProps };
